import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom"
import { useContext } from "react";
import AuthContext from "context/AuthContext";
import { filterNavsBymodel, filterNavsByRole, filterNavsByPanel } from "core/navsfilters";

const MenuButtons = (props) => {
    const [t] = useTranslation("routes")
    const naturalClass = "d-block ms-auto me-auto"
    const { user, panel } = useContext(AuthContext);

    const filteredNavsPanel = filterNavsByPanel(props.navs, panel);
    const filteredNavs = filterNavsByRole(filteredNavsPanel, user);
    const filteredNavsModel = filterNavsBymodel(filteredNavs, user);

    return (
        <div className="row">
            <div className="col-12">
                <div className="menubody-buttons">
                    {
                        filteredNavsModel.map((item, idx) =>
                            <div className="d-inline-block menu-button mt-3" key={idx}>
                                <Link to={item.url} data-rr-ui-event-key={item.url}
                                    className="d-inline-block text-center bg-primary text-light">
                                    <FontAwesomeIcon
                                        icon={item.icon}
                                        className={"className" in item ? naturalClass + " " + item.className : naturalClass}
                                    />
                                    <div className="menu-text pt-3">{t(item.name)}</div>
                                </Link>
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    );
}
export default MenuButtons